<template>
    <div v-if="isLoaded">
        <BoxPaciente
            ref="BoxPaciente"
            :data="{ form, model }"
        />

        <rkm-tabs
            v-model="tabIndex"
        >
            <rkm-tab
                title="Dispensação"
                active
            >
                <TabDispensacao
                    ref="TabDispensacao"
                    :form="form"
                    :model="model"
                    @save="handleSave"
                />
            </rkm-tab>

            <rkm-tab
                title="Histórico"
            >
                <TabHistorico
                    ref="TabHistorico"
                    :form="form"
                />
            </rkm-tab>
        </rkm-tabs>
    </div>
</template>

<script>
import BoxPaciente from '@/components/almoxarifado/paciente/Index'
import { repository, object, error, stringCase, data, request, printAlmoxarifado } from '@/mixins'
import TabDispensacao from './tabs/Dispensacao'
import TabHistorico from './tabs/Historico'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    components: {
        BoxPaciente,
        TabDispensacao,
        TabHistorico
    },
    created() {
        this.repositories = {
            dispensacaoMateriais: this.getConectaSusRepository('almoxarifado.dispensacaoMateriais'),
        }
        this.load()
    },
    data: () => ({
        tabIndex: 0,
        isLoaded: false,
        form: null,
        model: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'unsetShowExitFormConfirmation']),
        load() {
            if(this.pacienteId) {
                this.setLoading()
                this.repositories.dispensacaoMateriais.create(this.pacienteId)
                    .then(({ data }) => {
                        this.setShowDetails(data.form.historico)
                        this.form = this.clone(data.form)
                        this.model = this.clone(data.model)
                        this.isLoaded = true
                        this.$emit('paciente', this.form.paciente)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        setShowDetails(dispensacoes) {
            dispensacoes.forEach(dispensacao => {
                dispensacao._showDetails = true
            })
        },
        save() {
            this.$refs.TabDispensacao.save()
        },
        hasModelChanged() {
            return this.form.historico.some(h => h.items.some(i => !i.estornoSalvo && !!i.estornado)) || this.model.items.length > 0
        },
        handleSave() {
            if(!this.hasModelChanged()) {
                this.showAlert('Não é possível finalizar, pois nenhuma ação foi realizada.', 'Atenção')
                return
            }
            this.setLoading()
            this.repositories.dispensacaoMateriais.store(this.prepareData())
                .then(({ data }) => {
                    if(data.id) {
                        this.showConfirmation("Deseja imprimir o recido do material?",
                            async () => {
                                this.$nextTick()
                                    .then(() => this.handlePrint(data))
                                    .then(() => this.afterSave())
                            }
                        )
                    } else {
                        this.$nextTick().then(() => this.afterSave())
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {
            let estornados = []
            this.form.historico.forEach(dispensacao => dispensacao.items.forEach(item => {
                if(!item.estornoSalvo && !!item.estornado) {
                    estornados.push(item.id)
                }
            }))
            return {
                paciente_id: this.pacienteId,
                usuario_id: this.model.medicoSolicitante ? this.model.medicoSolicitante.id : null,
                data_dispensacao: this.model.dataDispensacao ? moment(this.model.dataDispensacao, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                observacao: this.model.observacao,
                items: this.model.items.map(item => {
                    return {
                        material_id: item.material.id,
                        quantidade: item.quantidade,
                        dispensado_em: moment(item.dispensadoEm, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                        observacao: item.observacao
                    }
                }),
                estornados: estornados
            }
        },
        afterSave() {
            this.$nextTick().then(() =>  {
                this.showSaveNotification(
                    null,
                    async () => {
                        this.unsetShowExitFormConfirmation()
                        this.$router.push({ name: 'almoxarifado-dispensacao-materiais-index' })
                })
            })
        },
        handlePrint(data) {
            let printData = {
                medicoNome: this.model.medicoSolicitante.cidadaoNome,
                materiais: this.model.items,
                pacienteNome: this.form.paciente.cidadao.nome,
                pacienteNomeSocial: this.form.paciente.cidadao.nomeSocial,
                prontuario: this.form.paciente.prontuario,
                dataNascimento: this.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
                dataAtual: this.form.dataAtual,
                dataEntrega: data.dispensadoEm,
                horaAtendimento: data.horaAtendimento,
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                unidade: this.form.unidade,
                telefone: this.form.telefone,
            }
            this.print().dispensacao(printData)
        },
    },
    mounted() {
        this.tabRefs = [
            this.$refs.TabDispensacao,
            this.$refs.TabHistorico,
        ]
    },
    mixins: [ repository, object, error, stringCase, data, request, printAlmoxarifado ],
    props: {
        pacienteId: { type: Number, required: true }
    }
}
</script>